import { text } from "../constants/tailwind-theme";
import sponser1 from '../assets/images/sponsors/1.png'
import sponser2 from '../assets/images/sponsors/2.png'
import sponser3 from '../assets/images/sponsors/3.png'
import sponser4 from '../assets/images/sponsors/4.png'
import sponser5 from '../assets/images/sponsors/5.png'
import sponser6 from '../assets/images/sponsors/6.png'
import sponser7 from '../assets/images/sponsors/7.png'
import sponser8 from '../assets/images/sponsors/8.png'
import sponser9 from '../assets/images/sponsors/9.png'

const FooterWithSponsers = () => {

    return (
        <div className="flex flex-row flex-wrap w-full items-center justify-evenly bg-white my-4 overflow-hidden">

            <img className=" w-24 h-20 object-cover" src={sponser1} alt="sponser1" />
            <img className=" w-24 h-20 object-cover" src={sponser2} alt="sponser2" />
            <img className=" w-24 h-20 object-cover" src={sponser3} alt="sponser3" />
            <img className=" w-24 h-20 object-cover" src={sponser4} alt="sponser4" />
            <img className=" w-24 h-20 object-cover" src={sponser5} alt="sponser5" />
            <img className=" w-24 h-20 object-cover" src={sponser6} alt="sponser6" />
            <img className=" w-24 h-20 object-cover" src={sponser7} alt="sponser7" />
            <img className=" w-24 h-20 object-cover" src={sponser8} alt="sponser8" />
            <img className=" w-24 h-20 object-cover" src={sponser9} alt="sponser9" />

        </div>
    )
}

export default FooterWithSponsers;